module.exports = __webpack_public_path__ + "media/images/pic/special_courses-604432c5a705d0917d9014d46a04c000.svg";